import React, { useState, useEffect } from "react";
import UserService from "../services/user.service";
import logo from "../assets/images/VioletCross.png";
import background from "./52logo.png";
import { Link } from "react-router-dom";

const Home = ({ register = 0, login = 0 , dawraImageUrl, dawraNumber}) => {
  const [imageUrl, setImageUrl] = useState("");

  // Convert Western/English numerals to Arabic-Indic numerals
  const toArabicNumerals = (num) => {
    if (!num) return "";
    const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return String(num).replace(/\d/g, (digit) => arabicNumerals[digit]);
  };

  // Use props directly, with fallback to sessionStorage
  const registerValue = register || parseInt(sessionStorage.getItem("register")) || 0;
  const loginValue = login || parseInt(sessionStorage.getItem("login")) || 0;
  const dawraNumberValue = dawraNumber || sessionStorage.getItem("dawra_number") || "";
  const dawraNumberArabic = toArabicNumerals(dawraNumberValue);
  
  // Update image when dawraImageUrl prop changes or check sessionStorage
  useEffect(() => {
    const storedImage = sessionStorage.getItem("dawra_image");
    const finalImageUrl = dawraImageUrl || storedImage;
    setImageUrl(finalImageUrl);
  }, [dawraImageUrl]);
  

  return (
    <div className="container">
      <div className="card text-center glass-card">
        <div className="card-header">
          <img
            src={logo}
            alt="Logo"
            style={{ width: "100%", height: "auto", maxWidth: "261px" }}
          />
        </div>
        <div className="card-body">
          <h3 className="card-title title-main">
            كنيسة الشهيد العظيم مارمرقس الرسول بمصر الجديدة
          </h3>
          <h3 className="card-title title-sub">
            <span className="line-before"></span>
            دورة المخطوبين {dawraNumberArabic !== "" ? "ال " + dawraNumberArabic : ""}
            <span className="line-after"></span>
          </h3>

          <div className="text-right" style={{ marginTop: "20px" }}>
            <div className="text-center">
              {loginValue == 1 && (
                <Link
                  to="/login"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  <button className="btn btn-primary-custom btn-lg">
                    تسجيل الدخول
                  </button>
                </Link>
              )}
              {registerValue == 1 &&
                <Link to="/register" style={{ textDecoration: "none" }}>
                  <button
                    className="btn btn-primary-custom btn-lg"
                    style={{
                      margin: "5px",
                      backgroundColor: "#CBA709",
                    }}
                  >
                    تسجيل جديد
                  </button>
                </Link>
              }
            </div>
          </div>
        </div>
      </div>
      <div className="card text-center glass-card">
        <div className="card-body">
          <img
            src={imageUrl}
            alt="Logo"
            style={{ width: "100%", height: "auto", maxWidth: "700px" }}
          />
        </div>
      </div>
    </div >
  );
};

export default Home;
